import { Injectable } from '@angular/core';
import { AngularFirestoreDocument, AngularFirestore } from '@angular/fire/firestore';
import * as firebase from 'firebase';
import { map } from 'rxjs/operators';
import { Roadbook } from '../models/roadbook.model';

@Injectable({
  providedIn: 'root'
})
export class EventRoadService {

  database = 'Roadbooks';
  databaseTrash = 'RoadbooksTrash';
  roomEscapeDoc: AngularFirestoreDocument<Roadbook>;
  constructor(
    private afs: AngularFirestore) { }


  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  } get ref() {
    return firebase.firestore().collection(this.database);
  }

  create(roadbook: Roadbook) {
    roadbook.id = this.afs.createId();
    return this.ref.firestore.doc(this.database + '/' + roadbook.id).set(Object.assign({}, roadbook));
  }
  edit(roadbook: Roadbook) {
    return this.ref.firestore.doc(this.database + '/' + roadbook.id).set(Object.assign({}, roadbook));
  }
  remove(roadbook: Roadbook) {
    this.ref.firestore.doc(this.databaseTrash + '/' + roadbook.id).set(Object.assign({}, roadbook));
    return this.ref.firestore.doc(this.database + '/' + roadbook.id).delete();
  }
  editVisible (roadbook: Roadbook, visible: Boolean) {
    this.ref.firestore.doc(this.database + '/' + roadbook.id).update({ visible: visible});
  }
  getAll() {
    return this.afs.collection<Roadbook>(this.database).snapshotChanges().pipe(map(actions => actions.map(a => {
      return a.payload.doc.data();
    })));
  }
}
